import { render, staticRenderFns } from "./ApproverAvatarStack.vue?vue&type=template&id=42dc5c61"
import script from "./ApproverAvatarStack.vue?vue&type=script&lang=js"
export * from "./ApproverAvatarStack.vue?vue&type=script&lang=js"
import style0 from "./ApproverAvatarStack.vue?vue&type=style&index=0&id=42dc5c61&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports